module.exports = __webpack_public_path__ + "assets/img/00070.da98169f.png";